import React from 'react'
import { InfoBox } from '@mobi/component-library/Feedback/InfoBox'
import { prettifyDistance } from '../../Utils/geoFenceUtils'
import { Container, Distance, Explainer, Title, TopMessage } from './Notices.styles'
import { ClosestVenue } from '../../Utils/geoFenceUtils'
import { VenueModeButton } from '@core/Areas/VenueMode/Components/Shared/VenueModeButton'
import { BENEFITS_EXPLAINER_TEXT, BENEFITS_EXPLAINER_TITLE } from '@core/Areas/VenueMode/constants'

interface OutsideVenueNoticeProps {
  closestVenue: ClosestVenue | undefined
  onFindTab: () => void
}

export const OutsideNotice = ({
  closestVenue,
  onFindTab,
}: OutsideVenueNoticeProps): React.JSX.Element => {
  return (
    <Container>
      <TopMessage>
        <Title>{BENEFITS_EXPLAINER_TITLE}</Title>
        <Explainer>{BENEFITS_EXPLAINER_TEXT}</Explainer>
      </TopMessage>
      <InfoBox color='blue' size='sm' iconName='DuocolorMarkerPin04'>
        <Distance>
          {closestVenue ? (
            <>
              You're{' '}
              <span style={{ display: 'inline' }}>{prettifyDistance(closestVenue.distance)}</span>
              {` away from ${closestVenue.name}`}
            </>
          ) : (
            <span>Location N/A</span>
          )}
        </Distance>
      </InfoBox>
      <VenueModeButton onClick={onFindTab}>Find my TAB</VenueModeButton>
    </Container>
  )
}
